<template>
  <div v-if="data === 'admin'">
    <b-tag type="is-dark" :size="dataSize" :class="dataClass">Admin</b-tag>
  </div>
  <div v-else-if="data === 'org_admin'">
    <b-tag type="is-gold" :size="dataSize" :class="dataClass">Org. Admin</b-tag>
  </div>
  <div v-else-if="data === 'user'">
    <b-tag type="is-grey-1" :size="dataSize" :class="dataClass">User</b-tag>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
      type: String,
    },
    dataSize: {
      required: false,
      type: String,
      default: '',
    },
    dataClass: {
      required: false,
      type: String,
      default: '',
    },
  },
};
</script>
